import { CartographyTable } from "src/brand/EC/components/folder/cartography/CartographyTable";
import { FolderRadar } from "src/core/components/folder/FolderRadar";

export const FolderCartographie = () => {
  return (
    <div className="flex flex-col w-2/5 bg-background-secondary border-r border-border z-0 h-full gap-y-10 overflow-visible">
      <FolderRadar isOnePage={true} />
      <CartographyTable />
    </div>
  );
};
